import router from "./../router";
import axios from "axios";
import EventEmitter from "eventemitter3";

const authServer = process.env.VUE_APP_TAPTAGS_API_URL;

const fetcher = axios.create({ baseURL: authServer, withCredentials: true });

export default class AuthTaptags {
  userInfo = {};
  accessToken;
  idToken;
  expiresAt;
  authenticated = this.isAuthenticated();
  qualified_profile = this.isQualifiedProfile();

  authNotifier = new EventEmitter();
  guess_country() {
    return fetcher.get("/myprofile/cccheck").then((response) => {
      console.log(response);
      return response;
    });
  }
  register(cc, phone, password) {
    return fetcher
      .post("/authsms/check.json", { cc: cc, phone: phone, password: password })
      .then((response) => {
        console.log(response);
        return response;
      });
  }
  authsms_verify(cc, phone, code) {
    return fetcher
      .post("/authsms/verify.json", { cc: cc, phone: phone, code: code })
      .then((response) => {
        console.log(response);
        return response;
      });
  }
  change_password(old_password, new_password) {
    return fetcher
      .put("/myprofile/change_password.json", {
        old_password: old_password,
        new_password: new_password,
      })
      .then((response) => {
        console.log(response);
        return response;
      });
  }

  login(phone, password) {
    if (localStorage.getItem("profile_id") === true) {
      router.replace("home");
    }
    var that = this;
    return fetcher
      .post(`myprofile/login.json`, {
        phone: phone,
        password: password,
      })
      .then((response) => {
        console.log("mp/login.json", response);
        if (response.data.success == true) {
          console.log("success", "mp/login.json", response);
          localStorage.setItem("profile_id", response.data.profile_id);
          that.authenticated = true;
          that.qualified_profile = response.data.qualified_profile;
          that.authNotifier.emit("authChange", {
            authenticated: true,
            qualified_profile: response.data.qualified_profile,
            myprofile: response.data,
          });
          router.replace("home");
        } else {
          console.log("failure", "mp/login.json", response);
          that.authenticated = false;
          that.qualified_profile = false;
          that.authNotifier.emit("authChange", {
            authenticated: false,
            qualified_profile: false,
            login_message: response.data.message,
          });
        }
        return response;
      })
      .catch(function(error) {
        console.log(error);
      });
  }

  setSession(authResult) {}

  check_session() {
    this.renewSession();
  }

  renewSession() {
    var that = this;
    fetcher
      .get(`myprofile/check_session.json`, {})
      .then((result) => {
        if (result.data.success == true) {
          localStorage.setItem("profile_id", result.data.profile_id);
          localStorage.setItem(
            "qualified_profile",
            result.data.qualified_profile
          );
          that.authenticated = true;
          that.qualified_profile = result.data.qualified_profile;
          that.authNotifier.emit("authChange", {
            authenticated: true,
            qualified_profile: result.data.qualified_profile,
            myprofile: result.data,
            result: result,
          });
        } else {
          localStorage.removeItem("profile_id");
          localStorage.removeItem("qualified_profile");
          that.authenticated = false;
          that.qualified_profile = false;
          that.authNotifier.emit("authChange", {
            authenticated: false,
            qualified_profile: false,
            result: result,
          });
        }
      })
      .catch(function(error) {
        console.log(error);
      });
  }

  logout() {
    var that = this;
    fetcher
      .delete(`myprofile/logout.json`, {})
      .then((result) => {
        localStorage.removeItem("profile_id");
        that.authenticated = false;
        that.qualified_profile = false;
        that.authNotifier.emit("authChange", {
          authenticated: false,
          qualified_profile: false,
        });
        router.push("/");
        return result;
      })
      .catch(function(error) {
        console.log(error);
      });
  }

  isQualifiedProfile() {
    // Check whether the current time is past the
    // access token's expiry time
    return localStorage.getItem("qualified_profile") === "true";
    //new Date().getTime() < this.expiresAt && localStorage.getItem('loggedIn') === 'true'
  }
  isAuthenticated() {
    // Check whether the current time is past the
    // access token's expiry time
    return Number.isInteger(parseInt(localStorage.getItem("profile_id")));
    //new Date().getTime() < this.expiresAt && localStorage.getItem('loggedIn') === 'true'
  }

  recover_phone_check(cc, phone, password) {
    return fetcher
      .post("/recover_phone/check.json", {
        cc: cc,
        phone: phone,
        password: password,
      })
      .then((response) => {
        console.log(response);
        return response;
      });
  }
  recover_phone_verify(cc, phone, code) {
    return fetcher
      .post("/recover_phone/verify.json", { cc: cc, phone: phone, code: code })
      .then((response) => {
        console.log(response);
        return response;
      });
  }
}
